// Thin client for the admin-only API. Separate cookie/session from the
// end-user Google-auth flow -- these calls hit /api/admin/*.
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

async function parseErrorMessage(res) {
  try {
    const data = await res.json();
    return data.detail || data.message || `Request failed (${res.status})`;
  } catch (e) {
    return `Request failed (${res.status})`;
  }
}

export async function adminMe() {
  const res = await fetch(`${API}/admin/me`, { credentials: 'include' });
  if (!res.ok) return null;
  return res.json();
}

export async function adminLogin(username, password) {
  const res = await fetch(`${API}/admin/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ username, password }),
  });
  if (!res.ok) throw new Error(await parseErrorMessage(res));
  return res.json();
}

export async function adminLogout() {
  await fetch(`${API}/admin/logout`, { method: 'POST', credentials: 'include' });
}

export async function adminStats() {
  const res = await fetch(`${API}/admin/stats`, { credentials: 'include' });
  if (!res.ok) throw new Error(await parseErrorMessage(res));
  return res.json(); // { total_users, users, signups_by_day }
}

export async function adminPosthogOverview() {
  const res = await fetch(`${API}/admin/posthog/overview`, { credentials: 'include' });
  if (!res.ok) throw new Error(await parseErrorMessage(res));
  return res.json(); // { daily_events, events_last_30_days, unique_people_last_30_days }
}

export async function downloadUsersCsv() {
  const res = await fetch(`${API}/admin/users.csv`, { credentials: 'include' });
  if (!res.ok) throw new Error(await parseErrorMessage(res));
  const blob = await res.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'waxify-signups.csv';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 5000);
}

export async function listFeatureRequests() {
  const res = await fetch(`${API}/admin/feature-requests`, { credentials: 'include' });
  if (!res.ok) throw new Error(await parseErrorMessage(res));
  return res.json(); // [{ id, message, email, created_at }]
}
